import * as React from 'react';
import { Checkbox, Link, Responsive, UIText3 } from '@cian/ui-kit';

import * as styles from './DisclaimerField.css';
import { NBSP } from '../../constants/symbols';

export interface IDisclaimerFieldProps {
  checked: boolean;
  disabled?: boolean;
  onChange(value: boolean): void;
  privacyPolicyUrl?: string;
  marketingAgreementUrl?: string;
  personalDataAgreementUrl?: string;
}

const PRIVACY_POLICY_URL = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/';
const MARKETING_AGREEMENT_LINK = 'https://www.cian.ru/legal-documents/soglasie_na_poluchenie_reklamnyx_rassylok_0/';
const PERSONAL_DATA_AGREEMENT_LINK =
  'https://www.cian.ru/legal-documents/soglasie_na_obrabotku_personalnyx_dannyx_razreshennyx_subektom_personalnyx_dannyx_dlya_rasprostraneniya_0';

/* istanbul ignore next */
export const DisclaimerField: React.FC<IDisclaimerFieldProps> = ({
  checked,
  disabled,
  onChange,
  privacyPolicyUrl = PRIVACY_POLICY_URL,
  marketingAgreementUrl = MARKETING_AGREEMENT_LINK,
  personalDataAgreementUrl = PERSONAL_DATA_AGREEMENT_LINK,
}) => {
  const handleChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <div className={styles['container']} data-testid="disclaimer-field">
      <div>
        <UIText3 color="text-secondary-default">
          Нажимая кнопку, я{NBSP}соглашаюсь на{NBSP}
          <Link fontSize="XS" inline href={personalDataAgreementUrl}>
            обработку персональных данных
          </Link>{' '}
          в{NBSP}соответствии с{NBSP}
          <Link fontSize="XS" inline href={privacyPolicyUrl}>
            политикой конфиденциальности
          </Link>
        </UIText3>
      </div>

      <Responsive desktop tablet>
        <div className={styles['agreement-checkbox']}>
          <Checkbox
            id="cbw-user-agreement"
            checked={checked}
            disabled={disabled}
            onChange={handleChange}
            data-testid="user-agreement"
            dataTestId="user-agreement"
          />
          <label className={styles['label']} htmlFor="cbw-user-agreement">
            <UIText3 color="text-secondary-default">
              Соглашаюсь на{NBSP}
              <Link fontSize="XS" inline href={marketingAgreementUrl}>
                рассылки и звонки
              </Link>
            </UIText3>
          </label>
        </div>
      </Responsive>

      <Responsive phone>
        <div className={styles['agreement-checkbox--mobile']}>
          <label htmlFor="cbw-user-agreement">
            <UIText3 color="text-secondary-default">
              Соглашаюсь на{NBSP}
              <Link fontSize="XS" inline href={marketingAgreementUrl}>
                рассылки и звонки
              </Link>
            </UIText3>
          </label>

          <Checkbox
            id="cbw-user-agreement"
            checked={checked}
            disabled={disabled}
            onChange={handleChange}
            data-testid="user-agreement"
            dataTestId="user-agreement"
          />
        </div>
      </Responsive>
    </div>
  );
};
